import { Close } from "@mui/icons-material";
import { Button, Tooltip, Typography } from "@mui/material";
import { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { StyledFlex } from "../../styled/flex";
import { StyledPrintAndDownloadDialog } from "../../styled/printAndDownload";
import CircularLoading from "../loadingData/circularLoading";
import CustomDialog from "./customDialog";

const PrintAndDownloadDialog = ({
  maxWidth = "sm",
  openModal,
  handleCloseModal,
  childComponent,
  printComponent = null,
  loading,
  disableCancelButton = false,
  disablePrintButton = false,
  disableDownloadButton = false,
  handleDownload,
  showCancelButton = true,
  showDownloadButton = true,
  showPrintButton = true,
  title,
  reactToPrintProps = {},
  onBeforePrint,
}) => {
  const componentRef = useRef();
  const [printing, setPrinting] = useState(false);

  const showActionButtons =
    showCancelButton || showDownloadButton || showPrintButton;

  const handlePrint = useReactToPrint({
    ...reactToPrintProps,
    contentRef: componentRef
  });

  const handlePrintClick = () => {
    if (typeof onBeforePrint !== "function") {
      handlePrint();
      return;
    }

    setPrinting(true);
    onBeforePrint()
      .then((permitido) => {
        if (permitido) handlePrint();
      })
      .finally(() => setPrinting(false));
  };

  return (
    <>
      <CustomDialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth={maxWidth}
      >
        <StyledPrintAndDownloadDialog.TitleContainer>
          <StyledFlex.Title>
            <Typography
              sx={{
                color: "white",
                fontWeight: "bold",
                textTransform: "upperCase",
              }}>
              {title}
            </Typography>
          </StyledFlex.Title>
          <Tooltip title="Cerrar">
            <Close
              onClick={handleCloseModal}
              sx={{ color: "white", cursor: "pointer", width: 25, height: 25 }}
            />
          </Tooltip>
        </StyledPrintAndDownloadDialog.TitleContainer>
        {loading ? (
          <StyledPrintAndDownloadDialog.LoadingContainer>
            <CircularLoading />
          </StyledPrintAndDownloadDialog.LoadingContainer>
        ) : (
          <div>
            <StyledPrintAndDownloadDialog.DialogContainer
              showActionButtons={showActionButtons}>
              {childComponent}
            </StyledPrintAndDownloadDialog.DialogContainer>
            {showActionButtons && (
              <StyledPrintAndDownloadDialog.Actions>
                {showCancelButton && (
                  <Button
                    onClick={handleCloseModal}
                    color="primary"
                    disabled={disableCancelButton}>
                    Cancelar
                  </Button>
                )}
                {showDownloadButton && (
                  <Button
                    onClick={handleDownload}
                    color="primary"
                    disabled={disableDownloadButton}
                    variant="contained">
                    Descargar
                  </Button>
                )}
                {showPrintButton && (
                  <Button
                    onClick={handlePrintClick}
                    color="primary"
                    disabled={disablePrintButton || printing}
                    variant="contained">
                    Imprimir
                  </Button>
                )}
              </StyledPrintAndDownloadDialog.Actions>
            )}
          </div>
        )}
      </CustomDialog>
      {showPrintButton && (
        <StyledPrintAndDownloadDialog.PrintButtonContainer>
          <StyledPrintAndDownloadDialog.PrintButton ref={componentRef}>
            {!!printComponent ? printComponent : childComponent}
          </StyledPrintAndDownloadDialog.PrintButton>
        </StyledPrintAndDownloadDialog.PrintButtonContainer>
      )}
    </>
  );
};

export default PrintAndDownloadDialog;
